<template>
  <div ref="entryElementRef">
    <div v-if="entry.text.html" class="relative space-y-4" v-html="entry.text.html"></div>
    <span v-if="!hidesource && source" class="text-xs">
      <span class="font-bold">{{ $t('news-page.source') }}:</span>
      <OLink class="text-o-blue" rel="noopener noreferrer nofollow" target="_blank" :href="source">{{ sourceText }}</OLink>
    </span>
  </div>
  <!-- <pre v-else class="whitespace-pre-wrap text-xs border-red-500 border">{{ entry }}</pre> -->
</template>

<script>
import { computed, defineComponent, ref } from '@nuxtjs/composition-api';
import { useTracking } from '@/modules/tracking/composables/useTracking';
import { truncate } from 'lodash';
import EntryImage from './EntryImage';
import RenderHtml from '~/modules/common/components/RenderHtml.vue';
import { OLink } from '~/modules/common/components/ui';

export default defineComponent({
  components: { EntryImage, RenderHtml, OLink },
  props: {
    entry: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const source = computed(() => props.entry.urls.source);
    const hidesource = computed(() => props.entry.metadata?.hidesource);
    const sourceText = computed(() => truncate(props.entry.urls.source, { length: 40 }));

    // Event Click Handlers For Analytics
    const entryElementRef = ref();
    const { initiliazeEntryEvents } = useTracking();
    initiliazeEntryEvents(entryElementRef);

    return { hidesource, source, sourceText, entryElementRef };
  },
});
</script>
